import React from "react";

const DEFAULT_BLOCK_ID = "C-A-1598227-14";

export default class YandexRecWidget extends React.Component {
    componentDidMount() {
        const blockId = this.props.blockId || DEFAULT_BLOCK_ID;

        window.yaContextCb.push(() => {
            Ya.Context.AdvManager.renderWidget({
                renderTo: `yandex_rtb_${blockId}`,
                blockId,
            });
        });
    }

    render() {
        return <div id={`yandex_rtb_${this.props.blockId || DEFAULT_BLOCK_ID}`}></div>;
    }
}
